import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

interface DashboardState {
  isResizable: boolean;
  setIsResizable: (value: boolean) => void;
}

export const useDashboardStore = create<DashboardState>()(
  devtools(
    immer((set) => ({
      isResizable: false,

      setIsResizable: (value: boolean) =>
        set((state) => {
          state.isResizable = value;
        }),
    })),
    {
      name: 'DashboardStore',
      store: 'DashboardStore',
    },
  ),
);